/* eslint-disable */
//import liraries
import React, { Component } from 'react';
import { View, StyleSheet ,Image} from 'react-native';
import {
    Container, Icon, Header,
    Content, ListItem,
    CheckBox, Thumbnail,
    Text, Left, Body, Right, Item, Input
} from 'native-base';
import styles from './Styles/TextInputComponentStyles'
export default TextInputComponent = ({
    meta: { touched, error, warning }, input: { onChange, ...restInput }, type,
    title,
    placeholder,
    secureTextEntry,
    keyboardType,
    disabled,
    styleText,
    fieldName,
    source,
    size,
    defaultplaceholderColor
}) => {

    return (
        <View style={styles.container}>
            <View style={styles.content}>
                <Image source = {source} style = {styles.image} />
                <Input
                    placeholderTextColor={defaultplaceholderColor}
                    style = {[styles.textStyle,styleText]}
                    autoCapitalize={'none'}
                    {...restInput}
                    onChangeText={onChange}
                    keyboardType={keyboardType}
                    secureTextEntry={secureTextEntry}
                    placeholder={placeholder}
                    disabled={disabled}
                    value={title} />
            </View>
            <View>
                {touched && ((error && <Text style={{ color: 'red' }}>{error}</Text>) ||
                    (warning && <Text style={{ color: 'orange' }}>{warning}</Text>))}
            </View>
        </View>
    )
}



